const MODULE = 'TOAST'

export const ADD_TOAST = `${MODULE}_ADD_TOAST`
export const REMOVE_TOAST = `${MODULE}_REMOVE_TOAST`
